import wildlife from '../../imgs/wildlife.png'
import lakeSunset from '../../imgs/lake_sunset.jpg'
import { FiDownload, FiMail } from 'react-icons/fi'


const TabNewsletters = () => {

return(
  <div className='tab-wrapper'>
      <section className='page-hero compact-hero newsletter-hero'>
        <img className='hero-image' src={lakeSunset} alt="Sunset reflected on Greenwood Lake" />
        <div className='hero-shade'></div>
        <div className='hero-content'>
          <span className='eyebrow'><FiMail /> Community news</span>
          <h1>The Indian Park newsletter</h1>
          <p>Updates, reminders, and stories from around the neighborhood.</p>
        </div>
      </section>

      <section className='page-section newsletter-section'>
        <div className='newsletter-intro'>
          <div>
            <span className='eyebrow dark'>Latest issue</span>
            <h2>Community news · March 2025</h2>
            <p>Read the latest issue below or download a copy to keep.</p>
          </div>
          <a className='primary-link' href="/PDFs/newsletter_3_25_25.pdf" target="_blank" rel="noopener noreferrer">
            <FiDownload /> Download PDF
          </a>
        </div>
        <div className='newsletter-layout'>
          <aside className='newsletter-aside'>
            <img src={wildlife} alt="Wildlife photographed around Indian Park, including guinea fowl, a fox, and a bear" />
            <div>
              <span>Seen around the park</span>
              <p>Indian Park shares the mountain with an incredible variety of wildlife. Please admire our wild neighbors from a safe distance.</p>
            </div>
          </aside>
          <div className='pdf-frame-shell'>
            <iframe
              src="/PDFs/newsletter_3_25_25.pdf"
              title="Indian Park newsletter — March 2025"
            />
          </div>
        </div>
      </section>
  </div>
)

}

export default TabNewsletters
